import { updateUser, getCurrentUser } from './connect';
import * as ActionTypes from 'constants';
import { callApi } from 'api';

export const initDashboard = () => ({
	type : ActionTypes.INIT_DASHBOARD
})

export const getUser = () => ({
	type : ActionTypes.GET_USER
})

export const clearUser = () => ({
	type : ActionTypes.CLEAR_USER
})

export const beginInitUsers = (proxy_account) => ({
	type : ActionTypes.BEGIN_INIT_USERS,
	payload : proxy_account
})

export const beginInitProxyLogin = (action) => ({
	type : ActionTypes.INIT_PROXY_USER_LOGIN,
	payload : action
})

export const setTmpUserRoles = (roles) => ({
	type : ActionTypes.SET_TMP_USER_ROLES,
	payload : roles
})

export const setTmpUserFeatures = (features) => ({
	type : ActionTypes.SET_TMP_USER_FEATURES,
	payload : features
})

export const initCreateUser = () => ({
	type : ActionTypes.INIT_CREATE_USER
})

export const beginCreateUser = (user) => ({
	type : ActionTypes.BEGIN_CREATE_USER,
	payload : user
})

export const beginSignupClientAdmin = (user) => ({
	type : ActionTypes.BEGIN_SIGNUP_CLIENT_ADMIN,
	payload : user
})

export const beginEditUser = (user) => ({
	type : ActionTypes.BEGIN_EDIT_USER,
	payload : user
})

export const initUsersChildren = () => ({
	type : ActionTypes.INIT_USERS_CHILDREN
})

export const initUserAvatars = (avatars) => ({
	type : ActionTypes.INIT_DASHBOARD_AVATARS,
	payload : avatars
})

export const toggleMapsInitFlag = (val) => ({
	type : ActionTypes.TOGGLE_MAPS_INIT_FLAG,
	payload : val
})

export const setOpenTab = (tab) => ({
	type : ActionTypes.SET_OPEN_TAB,
	payload : tab
})

export const setPasswordTabDirty = () => ({
	type : ActionTypes.SET_PASSWORD_TAB_DIRTY
})

export const setGenInfoTabDirty = () => ({
	type : ActionTypes.SET_GEN_INFO_TAB_DIRTY
})

export const setProfilePicDirty = () => ({
	type : ActionTypes.SET_PROFILE_PIC_TAB_DIRTY
})

export const updateUserErrors = errors => {
	return {
		type : ActionTypes.UPDATE_USER_ERRORS,
		payload : {errors}
	}
}

export const addUser = (user) => {
	return {
		type : ActionTypes.ADD_USER,
		payload : {user}
	}
}

export const addClientToUser = (client) => ({
	type : ActionTypes.ADD_CLIENT_TO_USER,
	payload : client
})

export const showDeleteUserPrompt = () => ({
	type : ActionTypes.SHOW_DELETE_USER_PROMPT
})

export const beginDeleteUser = () => ({
	type : ActionTypes.BEGIN_DELETE_USER
})

export const hideDeleteUserPrompt = () => ({
	type : ActionTypes.HIDE_DELETE_USER_PROMPT
})

export const hideEditUserPrompt = () => ({
	type : ActionTypes.HIDE_EDIT_USER
})

export const removeUser = (user_id, updatedChildren) => {
	return {
		type : ActionTypes.REMOVE_USER,
		payload : {user_id, updatedChildren}
	}
}
export const addUsers = (users) => {
	return {
		type : ActionTypes.ADD_USERS,
		payload : {users}
	}
}

export const initChildren = (children) => ({
	type : ActionTypes.INIT_CHILDREN,
	payload : children
})

export const updateProxyChildren = (children) => ({
	type : ActionTypes.UPDATE_PROXY_CHILDREN,
	payload : children
})

export const editUser = (user) => {
	return {
		type : ActionTypes.EDIT_USER,
		payload : {user}
	}
}

export const updateUserParent = ({user_id, parent_id}) => {
	return {
		type : ActionTypes.SET_USER_PARENT,
		payload : {
			user_id,
			parent_id
		}
	}
}

export const updateTmpUser = tmp_user => ({
	type : ActionTypes.UPDATE_TMP_USER,
	payload : {tmp_user}
})

export const showCreateUser = f => ({
	type : ActionTypes.SHOW_CREATE_USER
})

export const hideCreateUser = f => ({
	type : ActionTypes.HIDE_CREATE_USER
})

export const showEditUser = tmp_user => ({
		type : ActionTypes.SHOW_EDIT_USER,
		payload : {tmp_user}
})

export const hideEditUser = f => ({
	type : ActionTypes.HIDE_EDIT_USER,
});

export const beginEditUserSaga = (user_id) => ({
	type : ActionTypes.BEGIN_EDIT_USER_SAGA,
	payload : user_id
})

export const showViewUser = (user) => ({
		type : ActionTypes.SHOW_VIEW_USER,
		payload : user
})

export const hideViewUser = (user) => ({
	type : ActionTypes.HIDE_VIEW_USER,
	payload : user
})

export const loginProxyAccount = (user) => ({
	type : ActionTypes.LOG_IN_PROXY_ACCOUNT,
	payload : user
})

export const updateProxyAccount = (user) => ({
	type : ActionTypes.UPDATE_PROXY_ACCOUNT,
	payload : user
})

export const logoutProxyAccount = () => ({
	type : ActionTypes.LOG_OUT_PROXY_ACCOUNT
})

export const beginPasswordReset = (email) => ({
	type : ActionTypes.BEGIN_PASSWORD_RESET,
	payload : email
})

export const toggleFetchingTempHash = (val) => ({
	type : ActionTypes.TOGGLE_FETCHING_TEMP_HASH,
	payload : val
})

export const toggleResettingPassword = (val) => ({
	type : ActionTypes.RESETING_PASSWORD,
	payload : val
})

export const beginTempHashValidation = (id, hash) => ({
	type : ActionTypes.BEGIN_TEMP_HASH_VALIDATION,
	payload : {id, hash}
})

export const beginSaveNewPassword = (user) => ({
	type : ActionTypes.BEGIN_SAVE_NEW_PASSWORD,
	payload : user
})

export const beginValidateAccount = (number) => ({
	type : ActionTypes.BEGIN_VALIDATE_ACCOUNT,
	payload : number
})

export const searchUser = (name, account, callback) => {
	return (dispatch, getState) => {
		callApi('POST', '/users/search', { name, account }, 'application/json')
			.then(confirmation => {
				if(callback)
					callback(null, confirmation);
			})
			.catch(error => {
				if(callback)
					callback(error,null);
			})
	}
}

export function addFavorites(body, callback) {
	var _self = this;

	return (dispatch) => {
		const onTimeout = f => callApi('PUT', '/user/favorites', { ...body }, 'application/json')
			.then(editedUser => {
				if (typeof callback == 'function')
					callback(null, editedUser);
			})
			.catch(error => {
				if(callback) {
					callback(error, null);
				}
			});

		setTimeout(onTimeout, 1000);
	}
}

export var updateFeatures = (features) => {
	return {type : UPDATE_FEATURES, features};
}

export function getFeatures(callback) {
	var _self = this;
	return (dispatch) =>
		callApi('GET', '/users/features', null, 'application/json')
			.then(features => {
				dispatch(updateFeatures(features));
				if(typeof callback === 'function') callback(features);
			})
			.catch(error => {
				if(callback) {
					callback(error);
				}
			});
}

export const getUserChildren = (settings = {}, callback) => {
	var {limit, offset} = settings;

	return (dispatch, getState) => {
		var state = getState();
		callApi('POST', '/user/children', limit && offset ? ({ limit, offset }) : ({}), 'application/json')
			.then(({settings, children}) => {

				dispatch(addUsers(children));

				if(typeof callback === 'function')
					callback(null, children);
			})
			.catch(error => {
				if(typeof callback === 'function')
					callback(error, null);
			})
	}
}

export const setUserParent = ({user_id, parent_id}, callback) => {
	return (dispatch, getState) => {
		callApi('POST', '/user/parent', { user_id, parent_id }, 'application/json')
			.then(success => {
				dispatch(updateUserParent({ user_id, parent_id }));
				if(typeof callback === 'function')
					callback(null, success);
			})
			.catch(error => {
				if(typeof callback === 'function')
					callback(error, null);
			})
	}
}



// WEBPACK FOOTER //
// ./src/common/actions/user.js